export default "__VITE_ASSET__BXTCjQzg__"